import React, { useRef, useEffect } from 'react';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { FAQContent } from '../faqContent';
import { SESSION_STORAGE_KEYS } from '../../../constants/sessionStorageKeys';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';
import { FAQ_CODENAME } from '../../../constants/cmsCodeName';
import '../liveVet.scss';
import { scrollElementIntoView } from '../../../utils/scrollUtils';

export const PostConsultation = () => {
  const handleGoToDashboard = () => {
    localStorage.removeItem(SESSION_STORAGE_KEYS.LIVE_VET_SESSION);
    window.parent.location.href = CSPUrlsMap.dashboard.url;
  };

  const postConsultationRef = useRef(null);
  useEffect(() => {
    if (postConsultationRef) scrollElementIntoView(postConsultationRef.current);
  }, [postConsultationRef]);

  return (
    <div
      className="post-consultation"
      ref={postConsultationRef}
    >
      <div className="main-content">
        <h2>Vet consultation has ended</h2>
        <div className="petIcons">
          <Icon icon="paw" />
        </div>
        <h3>Thanks for using 24/7 live vet support!</h3>
        <span>You will be emailed a summary of the consultation, including any treatment plan.</span>

        <div className="button-container">
          <button
            type="submit"
            id="goToDashboardButton"
            className="button primary"
            onClick={handleGoToDashboard}
          >
            <span className="labelText">Back to Dashboard</span>
          </button>
        </div>
      </div>
      <FAQContent faqCategory={FAQ_CODENAME.LIVE_VET} />
    </div>
  );
};
